module.exports = __webpack_public_path__ + "static/img/bg-tit3.02c133a4.png";